@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<!-- ISSUER & SANCTION DATE -->
			<div class="row justify-content-start mt-3">
				<div class="col-sm-6">
					<label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.description' | translate }}
					</label>
					<textarea
						rows="2"
						class="w-100"
						pInputTextarea
						[pTooltip]="entity.description"
						tooltipPosition="top"
						[(ngModel)]="entity.description"
						fitContent="true"
						[disabled]="!formManipulation"
					></textarea>
				</div>
				<div class="col-sm-6">
					<label for="fine-name" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
						{{ 'general.date' | translate }}
					</label>
					<p-datepicker
						[disabled]="!formManipulation"
						[(ngModel)]="date"
						[showTime]="false"
						[style]="{ width: '200px' }"
						showIcon="true"
						appendTo="body"
						[firstDayOfWeek]="1"
						dateFormat="{{ i18n.dateFormat }}"
					></p-datepicker>
				</div>
			</div>
			<!-- taula de documents -->
			@if (!isNew) {
				<div class="row mt-3">
					<app-doc-table type="OBSERVATIONS" [entity]="entity" [nested]="true" [ids]="ids" (return)="refresh()">
					</app-doc-table>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (isNew) {
						<div>
							<button
								class="btn custom-button"
								[disabled]="!formManipulation"
								(click)="createObservation()"
								i18n
							>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew) {
						<div>
							<button class="btn custom-button" [disabled]="!formManipulation" (click)="save()" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
